import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import DeleteValidationType from 'src/features/validationTypes/components/forms/DeleteValidationType';
import UpdateValidationTypeFormModal from 'src/features/validationTypes/components/forms/UpdateValidationTypeFormModal';
import { validationTypesMessages } from 'src/features/validationTypes/utils/messages';
import { ValidationType } from 'src/features/validationTypes/utils/types';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

type CellValidationTypeActionsProps<TData, TValue> = CellContext<TData, TValue>;

export default function CellValidationTypeActions({ row }: CellValidationTypeActionsProps<ValidationType, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateValidationTypeFormModal
                        semantics={{
                            entryName: formatMessage(validationTypesMessages.type).toLowerCase(),
                        }}
                        selectedType={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateValidationTypeFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteValidationType
                        semantics={{
                            entryName: formatMessage(validationTypesMessages.type).toLowerCase(),
                        }}
                        selectedType={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteValidationType>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
